import type { GuideStep } from '../types';

export const ADVANCED_STEPS: GuideStep[] = [
  {
    id: 'advanced-1',
    page: 'index',
    section: 'advanced',
    target: 'topbar-ai',
    title: { sv: 'AI-assistenten', en: 'The AI assistant' },
    body: {
      sv: 'Beskriv vad du vill bygga i naturligt språk — AI:n genererar ett workflow-utkast som du kan finjustera.',
      en: 'Describe what you want to build in natural language — the AI generates a workflow draft you can fine-tune.',
    },
    placement: 'bottom',
    interests: ['ai-assistant'],
    order: 1,
  },
  {
    // AA4: introducera Diagram-quick-action (multi-sheet-templates)
    id: 'advanced-1b',
    page: 'index',
    section: 'advanced',
    target: 'ai-diagram-quick-action',
    title: { sv: 'Bygg multi-sheet-diagram', en: 'Build multi-sheet diagrams' },
    body: {
      sv: 'Diagram-knappen i AI-dialogen har färdiga mallar: arkitektur-karta, deploy-pipeline, state-machine m.fl. AI:n ställer upp sheets + cross-sheet-länkar åt dig. Du ser pipeline-status och uppskattad kostnad innan du kör.',
      en: 'The Diagram button in the AI dialog has ready-made templates: architecture map, deploy pipeline, state machine and more. The AI builds sheets + cross-sheet links for you. Pipeline status and estimated cost are shown before the run.',
    },
    placement: 'top',
    interests: ['ai-assistant'],
    order: 2,
  },
  {
    id: 'advanced-2',
    page: 'index',
    section: 'advanced',
    target: 'canvas',
    title: { sv: '3D-vy', en: '3D view' },
    body: {
      sv: 'Visualisera workflows med flera blad i en 3D-stack — bra för att kommunicera arkitektur till andra.',
      en: 'Visualize multi-sheet workflows as a 3D stack — great for communicating architecture.',
    },
    placement: 'auto',
    interests: ['3d-view'],
    order: 3,
  },
  {
    // D5: introducera Process-motor-knappen (Enterprise-only)
    id: 'advanced-2b',
    page: 'index',
    section: 'advanced',
    target: 'topbar-process-motor',
    title: { sv: 'Kör workflows som processer', en: 'Run workflows as processes' },
    body: {
      sv: 'Enterprise-plan låser upp process-motorn: kör workflow manuellt, trigga via HTTP-API eller webhook, eller schemalägg med cron. Klicka "Process" för att se run-historik + hantera API-nycklar, webhooks och scheman. AI-chatten kan också trigga runs åt dig efter godkännande.',
      en: 'Enterprise plan unlocks the process engine: run workflows manually, trigger via HTTP API or webhook, or schedule with cron. Click "Process" to see run history + manage API keys, webhooks and schedules. The AI chat can also trigger runs for you after approval.',
    },
    placement: 'bottom',
    interests: ['process-motor', 'enterprise'],
    order: 3,
  },
  {
    id: 'advanced-3',
    page: 'index',
    section: 'advanced',
    target: 'minimap',
    mobileTarget: null,
    title: { sv: 'Navigera stora workflows', en: 'Navigate large workflows' },
    body: {
      sv: 'Använd minikartan + Ctrl+1 (zoom to fit) + breadcrumbs tillsammans för att snabbt navigera stora, nästlade workflows.',
      en: 'Combine the minimap + Ctrl+1 (zoom to fit) + breadcrumbs to move quickly through large, nested workflows.',
    },
    placement: 'top',
    order: 4,
  },
];
